<template>
  <div class="right-menu__sing-in">
    <div class="right-menu__title">
      <h4>Вход</h4>
    </div>
    <div class="t-form form-margin">
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.phone }">
          <input
            type="text"
            id="sing-in-phone"
            @input="phoneFormat"
            :value="data.phone"
            maxlength="17"
            @click="() => clearError('phone')"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: data.phone }"
            for="sing-in-phone"
          >
            Номер телефона
            <span>*</span>
          </label>
          <span class="t-form__input-error">{{ errors.phoneText }}</span>
        </div>
      </div>
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.password }">
          <input
            type="password"
            id="sing-in-password"
            v-model="data.password"
            @click="() => clearError('password')"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: data.password }"
            for="sing-in-password"
          >
            Пароль
            <span>*</span>
          </label>
          <span class="t-form__input-error">{{ errors.passwordText }}</span>
        </div>
      </div>
      <div class="t-form__row">
        <div class="t-form__checkbox">
          <input
            type="checkbox"
            name="rememberme"
            id="rememberme"
            v-model="rememberMe"
          />
          <label for="rememberme">Запомнить меня</label>
        </div>
      </div>
    </div>
    <div class="right-menu__button-wrapper display-flex align-items-center">
      <t-button type="small blue uppercase" :callback="submit">Войти</t-button>
      <div>
        <span
          class="font-16"
          @click="
            togglePasswordrecovery();
            toogleSingin();
          "
          >Забыли пароль?</span
        >
      </div>
    </div>
    <div class="right-menu__link">
      <span
        class="font-18"
        @click="
          toogleSingin();
          toogleSingup();
        "
        >Зарегистрироваться</span
      >
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import Button from '@components/ui/button.vue';
import { router } from '@src/routes';
import Inputmask from 'inputmask';
import { setPhoneFormat, resetPhoneFormat } from '@src/js/inputMasks.js';

export default {
  components: {
    't-button': Button,
  },
  data: function () {
    return {
      data: {
        phone: '',
        password: '',
      },

      rememberMe: false,
      errors: {
        phone: false,
        phoneText: '',
        password: false,
        passwordText: '',
      },
      errorsText: {
        empty: 'Поле не должно быть пустым',
        shortPassword: 'Пароль должен быть 6 и более символов',
        mismatchPassword: 'Введеные пароли не совпадают',
        incorrectPassword: 'Неверный пароль',
        incorrectUser: 'Пользователя с таким телефоном не существует',
      },
    };
  },
  computed: {
    ...mapState('api', ['auth']),
  },
  methods: {
    ...mapMutations('params', [
      'toogleSingin',
      'toogleSingup',
      'togglePasswordrecovery',
      'toggleRightMenu',
      'toogleUserMenu',
      'toogleAuth',
      'setAuthOn',
    ]),
    ...mapActions('api', ['fetchRequest']),
    phoneFormat: function ({ target }) {
      this.data.phone = setPhoneFormat(target.value);
    },
    createPhone: function (value) {
      return resetPhoneFormat(value).slice(1);
    },
    form: function (data) {
      let _form = new FormData();
      Object.keys(data).forEach((item) => {
        _form.append(item, data[item]);
      });
      return _form;
    },
    validation: function () {
      let error = false;
      Object.keys(this.data).forEach((item) => {
        if (!this.data[item].trim()) {
          this.setErrors(item, 'empty');
          error = true;
        }
      });
    },
    setErrors: function (id, error) {
      this.errors[id] = true;
      this.errors[id + 'Text'] = this.errorsText[error];
    },
    setErrorsQuery: function (id, errorText) {
      this.errors[id] = true;
      this.errors[id + 'Text'] = errorText;
    },
    clearError: function (id) {
      this.errors[id] = false;
    },
    submit: function () {
      if (this.validation()) return;

      this.fetchRequest({
        url: this.auth,
        form: this.form({
          ...this.data,
          phone: this.createPhone(this.data.phone),
          rememberMe: this.rememberMe ? 1 : 0,
        }),
        success: (data) => {
          console.log('success', data);
          if (data.body.success) {
            this.setAuthOn();
            this.toggleRightMenu();
            this.toogleUserMenu();
            router.push('/personal');
          } else {
            Object.keys(data.body.errors).forEach((item) => {
              this.setErrorsQuery(item, data.body.errors[item][0]);
            });
          }
        },
        error: (e) => {
          console.log('error');
        },
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.form-margin
  margin-bottom: 32px
</style>



// WEBPACK FOOTER //
// src/templates/components/right-menu/ui/singin.vue